module.exports = __webpack_public_path__ + "img/background.22684b4a.jpg";